export default "__VITE_ASSET__5g5o2UKk__"